 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"197130475eed25e3fe33e46524e59d25f793a5e5","2":"9fc7b74efd18d8c1edefd5c597cea8d231f42e2f","3":"996045c667156a0a07266e4da528d4f97124c522","4":"9fd8c5ac","5":"da5a6fd19a9c68ed8a35c69dffafcbf90d15814c","7":"2e90d21a","9":"component---cache-gatsby-mdx-mdx-wrappers-dir-9-feca-0-cae-1-e-044103563-cb-921-a-80-fdb-4-scope-hash-a-60-b-927-e-3441491-f-70-d-79-e-942-a-0-a-079-e-js","10":"component---cache-gatsby-mdx-mdx-wrappers-dir-9-feca-0-cae-1-e-044103563-cb-921-a-80-fdb-4-scope-hash-c-8-f-3-c-0-ca-99729-c-4-f-073-c-51888-afc-9-f-01-js","11":"component---src-pages-404-js","12":"component---src-pages-about-careers-js","13":"component---src-pages-about-index-js","14":"component---src-pages-about-open-office-hours-js","15":"component---src-pages-about-studio-timeline-js","16":"component---src-pages-contact-js","17":"component---src-pages-index-js","18":"component---src-pages-open-source-health-design-js","19":"component---src-pages-services-js","20":"component---src-pages-thank-you-js","21":"component---src-pages-vision-coronavirus-index-js","22":"component---src-pages-vision-determinants-of-health-index-js","23":"component---src-pages-vision-digital-health-trends-2022-index-js","24":"component---src-pages-vision-faces-in-health-communication-index-js","25":"component---src-pages-vision-health-design-thinking-index-js","26":"component---src-pages-vision-health-visualizations-index-js","27":"component---src-pages-vision-healthcare-dollars-index-js","28":"component---src-pages-vision-index-js","29":"component---src-pages-vision-living-health-lab-index-js","30":"component---src-pages-vision-loneliness-in-our-human-code-index-js","31":"component---src-pages-vision-open-pro-index-js","32":"component---src-pages-vision-open-source-healthcare-index-js","33":"component---src-pages-vision-own-your-health-data-index-js","34":"component---src-pages-vision-patient-centered-consent-index-js","35":"component---src-pages-vision-physician-burnout-index-js","36":"component---src-pages-vision-precision-autism-index-js","37":"component---src-pages-vision-primary-self-care-algorithms-index-js","38":"component---src-pages-vision-test-treat-trace-index-js","39":"component---src-pages-vision-us-healthcare-problems-index-js","40":"component---src-pages-vision-vapepocolypse-index-js","41":"component---src-pages-vision-virtual-care-index-js","42":"component---src-pages-vision-who-uses-my-health-data-index-js","43":"component---src-pages-work-js","44":"dc3d4abf"}[chunkId]||chunkId) + "-" + {"0":"1041c4726d8cd1bf67c1","1":"d51758c8ef68c895402e","2":"867776ef955a26f7e4ee","3":"b8df9ad596bc31f95a49","4":"aee0cdb9beb3ecab5b82","5":"90bb4ae1392ff58561bf","7":"5d45b2f07613b8c36687","9":"73b77292d1203cb13515","10":"8a2420b76e10f8597127","11":"90eab5d28bb266dda7e8","12":"c27e2d21031f5bcc20b1","13":"f8cca14132e1c2cb3d7a","14":"2930e350070c26db619d","15":"4add4fef490c5df825a3","16":"6dd2333e704c36af8142","17":"cad81a4f572ed504aa05","18":"fc15acd8456a269a2c91","19":"5f7824631dc499e36b4a","20":"ddb666967ee42951e254","21":"6a526ec5581fcb173cf4","22":"0aed554432b912a77d52","23":"43672bbc0b8b2ec3fef9","24":"33d64c905dd0c7dbb550","25":"911393d400bb3983a7f0","26":"a9d008c30ff25528320b","27":"835a34c17aae3938020c","28":"7cd247133f01d41c90d0","29":"601eba88c65c09a5d645","30":"cfc13815c9b0251e06a5","31":"bb6a192d8e0068d2ad89","32":"11ad5a98c5f83082ebc0","33":"8a85c102fa86e30b18f4","34":"e78b23a2654e110fb0c4","35":"900b746b403644ce8df6","36":"73964754e386737b13f6","37":"d25fb8374f035dc068c7","38":"8c8626585bd4cf3e3547","39":"37013b20e658140e1729","40":"69006a16a71f1cc11ffe","41":"0a7e6dbef018a1e30cd4","42":"94e9976c6d39b5ebd5b2","43":"682181c774eaaecdff16","44":"b372f148d5073164b473"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
